// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconArrowRightSmallGrey: React.FC = () => {
    return (
        <svg
            version="1.1"
            width="5px"
            height="8px"
            viewBox="0 0 5.0 8.0"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="currentColor"
        >
            <defs>
                <clipPath>
                    <path d="M1366,0 L1366,6646 L0,6646 L0,0 L1366,0 Z"></path>
                </clipPath>
                <clipPath>
                    <path d="M6.125,0 L7,0.8 L3.5,4 L0,0.8 L0.875,0 L3.5,2.4 L6.125,0 Z"></path>
                </clipPath>
            </defs>
            <g transform="translate(-828.0 -1378.0)">
                <g clipPath="url(#i0)">
                    <g transform="translate(828.4999999999991 1378.5) rotate(-90.0) scale(-1.0 1.0)">
                        <g clipPath="url(#i1)">
                            <polygon points="0,0 7,0 7,4 0,4 0,0" stroke="none" fill="#CCCCCC"></polygon>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(IconArrowRightSmallGrey);
